import { TFunction } from '@shared/types/types'

export type FileSizeError = 'maxFileSize' | 'zeroFileSize'

export type FileSizeErrorFn = (error: FileSizeError) => void

export const MAX_FILE_SIZE_IN_MB = 10

export const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_IN_MB * 1024 * 1024

export const isFileSizeGreaterThanZero = (file: File): boolean => file.size > 0

export const getZeroSizeValidationMsg = (t: TFunction): string =>
  t('This file is empty (0 bytes), upload a different file')

export const getMaxSizeValidationMsg = (t: TFunction): string =>
  t('The file exceeds the {maxSize}MB size limit, upload a smaller file', {
    maxSize: MAX_FILE_SIZE_IN_MB.toLocaleString(),
  })

export const getImageValidationMsg = (t: TFunction): string =>
  t('Image type must be JPEG or PNG and less than {maxSize}MB', {
    maxSize: MAX_FILE_SIZE_IN_MB.toLocaleString(),
  })

export const getCsvValidationMsg = (t: TFunction): string => t('CSV file is required')

export const getXmlValidationMsg = (t: TFunction): string => t('XML file is required')
